<template>
  <b-container>
    <b-table 
      :items="items" 
      :fields="['unit','laatste_inspectie','huidige_inspectie','Actie']"
    >
      <template #cell(laatste_inspectie)="row">
        {{ moment(row.item.laatste_inspectie).format('L') }}
      </template>
      <template #cell(huidige_inspectie)="row">
        {{ moment(row.item.huidige_inspectie.datum).format('L') }}
      </template>
      <template #cell(Actie)="row">
        <b-button @click="$router.push({name: 'Prognoses',params: {id: row.item.id}})">
          Naar prognoses van unit
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";

  export default {
    name: 'InspectiePrognosesView',
    mixins: [serviceMixin],
    data() {
        return {
            items:[]
        }
    },
    mounted() {
      this.getInspecties()
    },
    methods: {
      getInspecties() {
        console.log('get Inspecties')
        var vm = this;
        // /inspecties/status
        this.get('/inspecties/status').then(response => {
          console.log(response.data)
          vm.items = response.data.inspecties
        })
      }
    }
  }    
</script>
